module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "u-mt4 u-mb4"
  }, [_c('h2', {
    staticClass: "secondary-header"
  }, [_vm._v(_vm._s(_vm.t('account.mfa')))])]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": _vm.t('account.enable_mfa'),
      "active-color": "#5AB67F",
      "inactive-color": "#CB6B0B",
      "value": _vm.mfaCheckboxValue
    },
    on: {
      "change": _vm.onMfaCheckBoxClick
    }
  }), _vm._v(" "), (_vm.isEnablingMfa) ? _c('div', [_c('p', {
    staticClass: "u-mt3"
  }, [_vm._v(_vm._s(_vm.t('account.authenticator_app_step1')))]), _vm._v(" "), _c('div', {
    staticClass: "center-qr"
  }, [_c('qr-code', {
    attrs: {
      "text": _vm.qrCode
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "l-flex-grid l-flex-grid--h-center"
  }, [_c('el-button', {
    staticClass: "el-button--primary u-text-uppercase",
    on: {
      "click": _vm.copySecret
    }
  }, [_c('fa-icon', {
    staticClass: "u-mr2",
    attrs: {
      "icon": ['far', 'copy']
    }
  }), _vm._v(" " + _vm._s(_vm.secret) + "\n      ")], 1)], 1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.t('account.authenticator_app_step2')))]), _vm._v(" "), _c('el-input', {
    staticClass: "item-input-field",
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.codeEntered),
      callback: function($$v) {
        _vm.codeEntered = $$v
      },
      expression: "codeEntered"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "el-button--primary u-text-uppercase u-width100",
    attrs: {
      "disabled": !_vm.codeEntered
    },
    on: {
      "click": _vm.handleTestMfaCode
    }
  }, [_vm._v("\n      " + _vm._s(_vm.t('account.verify_mfa')) + "\n    ")])], 1) : _vm._e()], 1)
},staticRenderFns: []}